import axiosClient from "./axiosClient";

export async function getCart() {
  const response = await axiosClient.get("/Carts");
  return response.data;
}

export async function addCartItem({ productId, variantId, quantity = 1, isWholesale = false }) {
  const response = await axiosClient.post("/Carts/items", {
    productId,
    variantId: variantId ?? null,
    quantity,
    isWholesale,
  });
  return response.data;
}

export async function updateCartItem(itemId, quantity) {
  const response = await axiosClient.put(`/Carts/items/${itemId}`, { quantity });
  return response.data;
}

export async function removeCartItem(itemId) {
  const response = await axiosClient.delete(`/Carts/items/${itemId}`);
  return response.data;
}
